import { ClubDrawer, DiamondDrawer, HeartDrawer, SpadeDrawer } from "./CardsSuitsDrawers";
export async function loadCardsShape(engine, refresh = true) {
    await engine.addShape(["spade", "spades"], new SpadeDrawer(), refresh);
    await engine.addShape(["heart", "hearts"], new HeartDrawer(), refresh);
    await engine.addShape(["diamond", "diamonds"], new DiamondDrawer(), refresh);
    await engine.addShape(["club", "clubs"], new ClubDrawer(), refresh);
}
